module.exports = __webpack_public_path__ + "img/mobile-vb-banner.eff91013.png";